<template>
  <div id="page-inforeq" class="d-flex">
    <!--MainBarMenu /-->
    <div class="layout-content container-fluid">
      <!--HeadingUser /-->
      <div class="row">
        <div class="col-12 pt-1" align="left">
          <router-link :to="'/freeuser/'+this.$route.params.cc">  
            <b-button variant="light">
              &lt;&lt;&lt;--- Volver atras
            </b-button>
          </router-link>
        </div>
      </div>
      <div class="page-inforeq py-3">        
        <div class="container">          
          <div class="row">
            <div class="col-12 col-md-6 col-lg-6 col-xl-6">
              
              <p class="title-3 mb-0">SOLICITUD DE PERMISOS SINDICAL - {{this.$route.params.id}}</p>
              <div class="cont-inforeq-text d-flex flex-column justify-content-around mt-0 mt-md-1">
              <!-- .cont-title> -->
                <form
                  action="#"
                  class="form-inforeq mt-5 mb-2 mb-md-5 align-items-center"
                  >
                  <div class="row">
                    <div class="col-12 mb-md-5">
                      <p class="title-1">Acá encontrarás todos los documentos relacionados con tu permiso sindical. Selecciona los archivos que quieres gestionar y luego decide qué quieres hacer con ellos.</p>
                    </div>  
                  </div>
                  <div class="row">
                    <div class="col-12 mb-md-0">
                      <p class="title-1"><b>Puedes escribir tu correo electrónico personal para enviar los archivos.</b></p>
                    </div>  
                  </div>
                  <div class="row">
                    <div class="col-4 ml-0 mb-md-0">
                      <p class="title-2 text-left">Correo electronico:</p>
                    </div>
                    <div class="col-5 ml-0 mb-md-5">
                      <input 
                        type="email"
                        required
                        placeholder="ejemplo@gmail.com" 
                        v-model="email"
                        class="form-control"
                        >
                    </div>
                    <div class="col-3 ml-0 mb-md-5">
                      <div v-if="!loading">
                        <b-button 
                          variant="light"
                          v-on:click="sendEmail"
                          >
                          Enviar archivos
                        </b-button>
                      </div>
                      <div v-else-if="loading" class="spinner-border" role="status">
                        <span class="sr-only">Loading...</span>
                      </div>
                    </div>
                  </div>
                  <div class="row"> 
                    <div v-if="validationEmail" class="col-12 text-right">
                      <b-alert show variant="danger">
                        Debe escribir su email y seleccionar al menos un documento.
                      </b-alert>
                    </div>
                    <div v-if="validationSendEmail" class="col-12 text-right">
                      <b-alert show variant="success">
                        El correo se envio correctamente.
                      </b-alert>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6 mb-md-0">
                      <p class="title-3 text-center">
                        <b>Documento</b>
                      </p>
                    </div>
                    <div class="col-3 mb-md-0">
                      <p class="title-3 text-center">
                        <b>Estado</b>
                      </p>
                    </div>  
                    <div class="col-3 mb-md-0">
                      <p class="title-3 text-center">
                        <b>Acciones</b>
                      </p>
                    </div>  
                  </div>
                  <div class="row">
                    <div class="col-6 mb-md-0">
                      <p class="title-3 text-left">
                        Solicitud permiso sindical
                      </p>
                      <p class="title-3 text-left">
                        Aprobación permiso sindical
                      </p>
                       <p v-show="this.tiquetes == 'approved'" class="title-3 text-left">                        
                        Tiquetes
                      </p>
                    </div>  
                    <div class="col-3 mb-md-0">
                      <p class="title-3 text-left">
                       .
                      </p>
                      <p class="title-3 text-left">
                        <img :src="require(`@/assets/images/icons/${iconSol}`)">
                        {{this.statusSolicitud}}
                      </p>
                      <p v-show="this.tiquetes == 'approved'" class="title-3 text-left">
                        <img :src="require(`@/assets/images/icons/${iconTkt}`)">
                        {{this.statusTicket}}
                      </p>
                    </div>
                    <div class="col-3 mb-md-0">
                     <p class="title-3 text-left">
                        <a :href="pathLicensePDF" target="_blank">
                          <img class="logoImg" src="@/assets/images/icons/eye.svg">
                          Ver
                        </a>|                        
                        <img class="logoImg" width="15" height="15" src="@/assets/images/icons/mail.svg">
                        <input 
                          v-model="license"
                          class="mycheck"
                          type="checkbox"
                        >
                      </p>
                      <p class="title-3 text-left">
                        <a :href="pathToApprovalPDF" target="_blank">
                          <img class="logoImg" src="@/assets/images/icons/eye.svg">
                          Ver dos
                        </a>|                        
                        <img class="logoImg" width="15" height="15" src="@/assets/images/icons/mail.svg">
                        <input
                          v-model="approval"
                          class="mycheck"
                          type="checkbox"
                        >
                      </p>
                      <p v-show="this.tiquetes == 'approved'" class="title-3 text-left">
                        <a :href="serverPath+'/'+this.tktFile" target="_blank">
                          <img class="logoImg" src="@/assets/images/icons/eye.svg">
                          Ver
                        </a>|
                          <img class="logoImg" width="15" height="15" src="@/assets/images/icons/mail.svg">
                          <input
                            v-model="tickets"
                            class="mycheck"
                            type="checkbox"
                          >
                      </p>                      
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 mt-md-5">
                      <router-link :to="'/absenteeism/'+this.$route.params.id+'/'+this.sharp_id" class="menu-button">
                        <p class="title-3 text-left">
                          <b>+Añadir formato para reporte de ausentismo</b>
                        </p>
                      </router-link>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 mb-md-5">
                      <table class="tabla1">
                        <thead>
                          <tr>
                            <th class="td1">Recuerda que debes legalizar tu permiso mediante SAM portal y tus viáticos mediante MOBILEXPENSE.</th>                        
                          </tr>
                          <tr>
                            <td class="td1"><b>ID Sharp: {{this.sharp_id}}</b></td>                        
                          </tr>
                          <tr>
                            <td class="td1">
                              <b-button v-b-modal.modal-1 class="button1">
                                <img class="responsive" src="@/assets/images/icons/sam.svg">
                              </b-button>
                                 -
                              <b-button v-b-modal.modal-2 class="button1"> 
                                <img class="responsive" src="@/assets/images/icons/mobilexpense.svg">
                              </b-button>
                            </td>
                          </tr>
                          <tr>
                            <td class="td1">Da clic en la plataforma que desees para visitarla</td>
                          </tr>
                        </thead>
                      </table>
                    </div>
                  </div>
                  
                </form>
              </div>
              <b-modal id="modal-1" title="Información para SAM" size="xl">
                <b-img
                  fluid 
                  alt="Responsive image"
                  :src="serverPath+this.modalsLocal[0].image"
                >
                </b-img>
              </b-modal>
              <b-modal id="modal-2" title="Información para MobileXpense" size="xl">
                <b-img
                  fluid 
                  alt="Responsive image"
                 :src="serverPath+this.modalsLocal[1].image"
                >
                </b-img>
              </b-modal>
            </div>
            <div class="col-12 col-md-6 col-lg-6 col-xl-6">
              <TemplateLetterFree
                :id = "this.$route.params.id"                
              />              
            </div>
          <!-- .col -->
          </div>
        <!-- .row -->
        </div>
      <!-- .layout-content -->
      </div>
    </div>
  </div>
  <!-- #page-request -->
</template>

<script>
import { mapActions, mapState } from "vuex";
import serverConfig from "./../../services/config";
//import TemplateLetter from "../approvals/TemplateLetter.vue";
import TemplateLetterFree from "./TemplateLetterFree.vue";

export default {
  name: "InfoRequest",
  components: {
    TemplateLetterFree,
  },
  data() {
    return {
      serverPath: serverConfig.permisosURL,
      error: {
        flag: false,
        class: "", //is-invalid
        message: "",
      },
      success: {
        flag: false,
        class: "", //is-valid
        message: "",
      },
      email: '',
      statusSolicitud: '',
      iconSol: 'circle-check.svg',
      statusTicket: '',
      iconTkt: 'circle-check.svg',      
      tiquetes: false,
      permiso: false,
      aprobacion: false,
      tktFile: "",
      sharp_id: "",
      tickets: "",
      license: "",
      approval: "",
      validationEmail: false,
      validationSendEmail: false,
      modalsLocal: [],
      society: '',
    };
  },
  beforeMount() {
    var data2 = [];
    data2[0] = this.$route.params.id;
    data2[1] = this.$route.params.idUser;
    this.actGetRequestFree(data2).then(() =>{
              this.statusSolicitud = 'Aprobado';
              this.iconSol = "circle-check.svg";
                let cont2 = 0;
                for(let i=0; i<this.requestFree.data.license_employees.length; i++){                  
                  if(this.requestFree.data.license_employees[i].core_employee.cc == this.$route.params.cc){
                    this.tiquetes = this.requestFree.data.license_employees[i].ticket.status; 
                    if(this.requestFree.data.license_employees[i].ticket.status == 'approved'){
                      this.statusTicket = 'Aprobado';
                      this.iconTkt = "circle-check.svg";
                      cont2 = 1;
                    }
                    else if(cont2 == 0){
                      this.statusTicket = 'No Aprobado';
                      this.iconTkt = "circle-clock.svg";
                    }
                    this.tktFile = this.requestFree.data.license_employees[i].ticket.image;
                    this.sharp_id = this.requestFree.data.license_employees[i].core_employee.sharp_id;
                  }
                }
                this.society = this.requestFree.data.society.name.id;

                }).catch((response) => {
                  this.error.flag = true;
                  this.error.class = "is-invalid";
                  this.error.message = "No se pudo conectar al servicio: "+response;
                });

    this.actGetModals().then(() =>{
      this.modalsLocal = this.modals.data;
    });

    let data = [];
    data[0] = this.$route.params.id;
    data[1] = this.$route.params.cc;
    this.actUpdateReadNtftn(data);
  
  },
  computed: {
    ...mapState("modRequest", ["requestFree","modals","loading"]),
    pathToApprovalPDF() {
     return this.paramId && this.society ? `${this.serverPath}/approvalPDF/${this.paramId}/${this.society}` : '#'
    },
    pathLicensePDF() {
      return `${this.serverPath}/licensePDF/${this.paramId}`
    }
    , paramId () {
      return parseInt(this.$route.params?.id || 0)
    }
  },
  methods: {
    ...mapActions("modRequest", [
    "actGetRequestFree",
    "actSendEmailDocs",
    "actGetModals",
    "actUpdateReadNtftn",
    ]),

    sendEmail(){
      if(this.email.length > 3){
        if(this.tickets || this.license || this.approval){
          this.validationEmail = false;
          let data = [];
          let info = {};
          info.docs = [];
          info.email = this.email;
          
          if(this.tickets){
            info.docs.push('ticket');
          }
          if(this.license){
            info.docs.push('license');
          }
          if(this.approval){
            info.docs.push('approval');
          }

          data[0] = this.$route.params.id;
          data[1] = info;

          //alert(JSON.stringify(data));
          this.actSendEmailDocs(data).then(() =>{
              this.validationSendEmail = true;
            });
        }
        else{
          this.validationEmail = true;
        }      
      }
      else{
        this.validationEmail = true;
      }
    },

  },
};
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Open+Sans&display=swap');
.page-inforeq {
  .title-3 {
        font-size: 22px;
        font-weight: bold;
        text-align: center;
        color: #1C3A4E;
      }
  .cont-inforeq-text {
    
    .title-1 {
      font-family: "Open Sans";
      font-size: 13px;
      line-height: 16px;
      font-weight: normal;
      color: #1C3A4E;
    }
    .title-2 {
      font-family: "Open Sans";
      font-size: 13px;
      line-height: 16px;
      font-weight: normal;
      color: #1C3A4E;
      align-content: center;
      text-align: center;
    }
    .title-3 {
      font-family: "Open Sans";
      font-size: 13px;
      line-height: 16px;
      font-weight: normal;
      color: #1C3A4E;
      align-content: center;
      text-align: right;
    }
    
    .form-inforeq {      
      .boton1 {
        background: #ffffff;
        color: #1C3A4E;
        border-color: #1C3A4E;
        font-family: "Poppins";
        border-radius: 5px;
        height: 32px;
        width: 170px;
        font-size: 14px;
        text-align: center !important;  
        padding-left: 15%;
        padding-right: 5%;
        &:hover {
          background: darken(#f6f8fa, 5);
        }
      }
      .boton2 {
        background: #8d9092;
        color: #ffffff;
        border-color: #8d9092;
        font-family: "Poppins";
        border-radius: 50px;
        height: 32px;
        width: 150px;
        font-size: 14px;
        text-align: center !important;  
        padding-left: 5%;
        padding-right: 5%;
        &:hover {
          background: darken(#7a7c7e, 5);
        }
      }
      .tabla1{  
        border-radius: 5px;
        border: 3px solid #ced2d3;
        border-color: #ced2d3;
        background: #ced2d3;  
        -moz-border-radius: 6px;
        border-collapse: separate;
        border-spacing: 0px;
        width: 530px;
        align-content: center;
        text-align: center;
      }
      .td1 {
        background: #ced2d3;
        color: #454545;
        font-family: "Open Sans";
        font-weight: normal;
        font-size: 12px;
        line-height: 19px;
        padding-left: 1%;
        padding-right: 1%;
        width: 100px;
      }
      .p1 {
        font-family: "Open Sans";
        font-style: normal;
        font-weight: 600;
        font-size: 15px;
        line-height: 22px;
        color: #1C3A4E;
      } 
    }
  }
  .button1 {
        background: #ffffff;
        color: #8d9092;
        border-color: #ffffff;
        font-family: "Poppins";        
        height: 42px;
        width: 120px;
        font-size: 14px;
        text-align: center !important;  
        padding-left: 2%;
        padding-right: 2%;
        border-radius: 4px;
        &:hover {
          background: darken(#ffffff, 5);
        }
  }
  .button2 {
        background: #ffffff;
        color: #8d9092;
        border-color: #ffffff;
        font-family: "Poppins";        
        height: 32px;
        width: 120px;
        font-size: 14px;
        text-align: center !important;  
        padding-left: 2%;
        padding-right: 2%;
        &:hover {
          background: darken(#ffffff, 5);
        }
  }
  .button4 {
        -webkit-appearance: button;
    -moz-appearance: button;
    appearance: button;

    text-decoration: none;
    color: initial;
  }  
  .p2 {
          font-family: "Open Sans";
          font-style: normal;
          font-weight: bold;
          font-size: 10px;
          line-height: 16px;
          color: #303030;
          padding-left: 5%;
          text-align: right;
          vertical-align: bottom;
          text-decoration: underline;
  }
  .p3 {
          font-family: "Open Sans";
          font-style: normal;
          font-weight: normal;
          font-size: 12px;
          line-height: 18px;
          color: #454545;
  }

  .responsive {
    width: 100%;
    height: auto;
  }
  .modalImage {
    margin: auto;
    display: block;
    width: 50%;
    height: 60%;
    max-width: 700px;
  }
  .img1 {
    width: 90px;
    height: 130px;
    //position: absolute;
    left: 50%;
    top: 50%; 
    margin-left: -2px;
    margin-top: -2px;
    //float: left;
    //fill: white;
    //clear: right;
    align-content: center;
  }
  .centerImg {
    width: 19px;
    height: 19px;
    //position: absolute;
    //left: 50%;
    top: 100%; 
    //margin-left: -8px;
    //margin-top: 8px;
    float: left;
    fill: white;
    //clear: right;
  }
  .row1 {
    align-content: center;
    background: #ced2d3;
  }
  .mycheck 
  { 
    vertical-align: middle;
    position: relative;
    bottom: 1px;
    margin: 0px 20px 0px 3px;
  }
}

</style>